import { EvaluationColor } from '@repo/types';

export const evaluationColorToCSSVariableMap: Record<EvaluationColor, string> =
  {
    grey: 'var(--warm-grey-300)',
    green: 'var(--green-200)',
    orange: 'var(--orange-200)',
    red: 'var(--red-200)',
  };
